// extracted by mini-css-extract-plugin
export default {"wrapper":"index_wrapper__Sltb3","box":"index_box__A1gju","note":"index_note__GeHOY"};